[
  {
    "name": "USA",
    "code": "USA"
  },
  {
    "name": "Canada",
    "code": "CA"
  }
]
